var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-topic-participants"},[_c('CommonHeader',[_vm._v(_vm._s(_vm.$t('feed.topic.participants')))]),_c('main',[_c('JoLoadMore',{ref:"loadmore",on:{"onRefresh":_vm.onRefresh}},_vm._l((_vm.participants),function(user){return _c('UserItem',{key:user.id,attrs:{"user":user}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }